import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import MenuItem from './MenuItem';
import { useLanguage } from '../../context/LanguageContext';

export default function MenuCategory({ category, items, isOpen = true }) {
  const [expanded, setExpanded] = useState(isOpen);
  const { language } = useLanguage();

  return (
    <div id={category.id} className="mb-8 scroll-mt-32">
      {/* Category Header */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-4 bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md transition-shadow md:cursor-default"
        aria-expanded={expanded}
      >
        <div className="text-left">
          <h2 className="font-display text-2xl font-bold text-gray-900 dark:text-white">
            {category.name[language]}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">
            {category.description[language]}
          </p>
        </div>
        <span className="md:hidden text-gray-400">
          {expanded ? (
            <ChevronUp className="w-6 h-6" />
          ) : (
            <ChevronDown className="w-6 h-6" />
          )}
        </span>
      </button>

      {/* Items */}
      <div
        className={`
          mt-4 space-y-4
          md:grid md:grid-cols-2 md:gap-4 md:space-y-0
          transition-all duration-300
          ${expanded ? 'block' : 'hidden md:grid'}
        `}
      >
        {items.map((item) => (
          <MenuItem key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}
